import {
  CheckCircle,
  ChevronDown,
  ChevronRight,
  Copy,
  // ExternalLink,
  FileText,
  // FolderOpen,
  // List,
  Pencil,
  Plus,
} from 'lucide-react'
import { useState } from 'react'
import { SiFramer } from 'react-icons/si'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import type {
  FramerCreateArticleResult,
  FramerGetArticleResult,
  // FramerGetPublishUrlsResult,
  // FramerListArticlesResult,
  // FramerListCollectionsResult,
  FramerPerformTaskResult,
  FramerUpdateArticleResult,
} from 'sprites-types/workflow/tools/framerActions'
import { framerActions } from 'sprites-types/workflow/tools/framerActions'
import { EnhancedMarkdown } from '../../ui/EnhancedMarkdown'
import { ContextMenuWrapper } from '../shared/ContextMenuWrapper'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text)
}

function CollapsibleList({
  title,
  itemCount,
  children,
  defaultExpanded = true,
}: {
  title: string
  itemCount: number
  children: React.ReactNode
  defaultExpanded?: boolean
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <div className="min-w-0 flex-1">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex w-full items-center gap-2 text-sm font-medium text-gray-900 transition-colors hover:text-gray-700"
      >
        {isExpanded ? (
          <ChevronDown className="h-4 w-4 flex-shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 flex-shrink-0" />
        )}
        <span>
          {title} ({itemCount})
        </span>
      </button>
      {isExpanded && <div className="mt-2 space-y-1.5">{children}</div>}
    </div>
  )
}

// function ListCollectionsDisplay({ data }: { data: FramerListCollectionsResult }) {
//   const contextActions = [
//     {
//       id: 'copy-collection-names',
//       label: 'Copy Collection Names',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         const names = data.collections.map((c) => c.name).join('\n')
//         await copyToClipboard(names)
//       },
//     },
//     {
//       id: 'copy-json',
//       label: 'Copy as JSON',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         await copyToClipboard(JSON.stringify(data, null, 2))
//       },
//     },
//   ]

//   return (
//     <ContextMenuWrapper actions={contextActions}>
//       <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
//         <div className="flex items-start gap-4 px-4 py-3">
//           <div className="mt-1 flex-shrink-0">
//             <div className="rounded-full bg-blue-100 p-2">
//               <FolderOpen className="h-5 w-5 text-blue-600" />
//             </div>
//           </div>
//           <div className="min-w-0 flex-1">
//             <div className="text-sm font-semibold text-gray-900">
//               Collections ({data.collections.length})
//             </div>
//             <div className="mt-2 space-y-2">
//               {data.collections.map((collection) => (
//                 <div
//                   key={collection.id}
//                   className="rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs"
//                 >
//                   <div className="font-medium text-gray-900">{collection.name}</div>
//                   <div className="mt-1 text-gray-600">{collection.fieldCount} fields</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </ContextMenuWrapper>
//   )
// }

// function ListArticlesDisplay({ data }: { data: FramerListArticlesResult }) {
//   const contextActions = [
//     {
//       id: 'copy-slugs',
//       label: 'Copy Slugs',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         const slugs = data.articles.map((a) => a.slug).join('\n')
//         await copyToClipboard(slugs)
//       },
//     },
//     {
//       id: 'copy-ids',
//       label: 'Copy IDs',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         const ids = data.articles.map((a) => a.id).join('\n')
//         await copyToClipboard(ids)
//       },
//     },
//     {
//       id: 'copy-json',
//       label: 'Copy as JSON',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         await copyToClipboard(JSON.stringify(data, null, 2))
//       },
//     },
//   ]

//   return (
//     <ContextMenuWrapper actions={contextActions}>
//       <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
//         <div className="flex items-start gap-4 px-4 py-3">
//           <div className="mt-1 flex-shrink-0">
//             <div className="rounded-full bg-purple-100 p-2">
//               <List className="h-5 w-5 text-purple-600" />
//             </div>
//           </div>
//           <div className="min-w-0 flex-1">
//             <div className="text-sm font-semibold text-gray-900">
//               Articles ({data.articles.length} of {data.total})
//             </div>
//             <div className="mt-2 space-y-2">
//               {data.articles.map((article) => (
//                 <div
//                   key={article.id}
//                   className="rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs"
//                 >
//                   <div className="flex items-center gap-2">
//                     <div className="font-medium text-gray-900">{article.slug}</div>
//                     {article.draft && (
//                       <span className="rounded-full bg-yellow-100 px-2 py-0.5 text-[10px] font-medium text-yellow-800">
//                         Draft
//                       </span>
//                     )}
//                   </div>
//                   <div className="mt-1 text-gray-600">ID: {article.id}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </ContextMenuWrapper>
//   )
// }

function GetArticleDisplay({ data }: { data: FramerGetArticleResult }) {
  const contextActions = [
    {
      id: 'copy-slug',
      label: 'Copy Slug',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.slug)
      },
    },
    {
      id: 'copy-id',
      label: 'Copy ID',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.id)
      },
    },
    {
      id: 'copy-json',
      label: 'Copy as JSON',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(JSON.stringify(data, null, 2))
      },
    },
  ]

  return (
    <ContextMenuWrapper actions={contextActions}>
      <div className="rounded-2xl border border-gray-200/50 bg-white/70 text-black shadow-sm">
        <div className="flex items-start gap-3 px-4 py-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-50">
            <SiFramer className="h-4 w-4 text-purple-600" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <FileText className="h-4 w-4 text-gray-500" />
              <span className="text-sm font-medium text-gray-900">Article Retrieved</span>
            </div>
            <div className="mt-2 rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs">
              <div className="flex items-center gap-2">
                <div className="font-medium text-gray-900">{data.slug}</div>
                {data.draft && (
                  <span className="rounded-md bg-yellow-100 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800">
                    Draft
                  </span>
                )}
              </div>
              <div className="mt-2 text-gray-600">ID: {data.id}</div>
              {Object.keys(data.fieldData).length > 0 && (
                <div className="mt-2">
                  <div className="font-medium text-gray-700">Fields:</div>
                  <div className="mt-1 space-y-1">
                    {Object.entries(data.fieldData).map(([key, value]) => (
                      <div key={key} className="text-gray-600">
                        <span className="font-medium">{key}:</span>{' '}
                        {typeof value === 'string' && value.length > 50
                          ? `${value.substring(0, 50)}...`
                          : String(value)}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ContextMenuWrapper>
  )
}

function CreateArticleDisplay({ data }: { data: FramerCreateArticleResult }) {
  const contextActions = [
    {
      id: 'copy-slug',
      label: 'Copy Slug',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.slug)
      },
    },
    {
      id: 'copy-id',
      label: 'Copy ID',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.id)
      },
    },
  ]

  return (
    <ContextMenuWrapper actions={contextActions}>
      <div className="rounded-2xl border border-gray-200/50 bg-white/70 text-black shadow-sm">
        <div className="flex items-start gap-3 px-4 py-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-50">
            <SiFramer className="h-4 w-4 text-purple-600" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <Plus className="h-4 w-4 text-gray-500" />
              <span className="text-sm font-medium text-gray-900">Article Created</span>
            </div>
            <div className="mt-2 rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs">
              <div className="flex items-center gap-2">
                <div className="font-medium text-gray-900">{data.slug}</div>
                {data.draft && (
                  <span className="rounded-md bg-yellow-100 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800">
                    Draft
                  </span>
                )}
              </div>
              <div className="mt-1 text-gray-600">ID: {data.id}</div>
            </div>
          </div>
        </div>
      </div>
    </ContextMenuWrapper>
  )
}

function UpdateArticleDisplay({ data }: { data: FramerUpdateArticleResult }) {
  const contextActions = [
    {
      id: 'copy-slug',
      label: 'Copy Slug',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.slug)
      },
    },
    {
      id: 'copy-id',
      label: 'Copy ID',
      icon: <Copy className="h-3.5 w-3.5" />,
      onClick: async () => {
        await copyToClipboard(data.id)
      },
    },
  ]

  return (
    <ContextMenuWrapper actions={contextActions}>
      <div className="rounded-2xl border border-gray-200/50 bg-white/70 text-black shadow-sm">
        <div className="flex items-start gap-3 px-4 py-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-50">
            <Pencil className="h-4 w-4 text-orange-600" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <SiFramer className="h-4 w-4 text-purple-600" />
              <span className="text-sm font-medium text-gray-900">
                Article {data.updated ? 'Updated' : 'Unchanged'}
              </span>
            </div>
            <div className="mt-2 rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs">
              <div className="flex items-center gap-2">
                <div className="font-medium text-gray-900">{data.slug}</div>
                {data.draft && (
                  <span className="rounded-md bg-yellow-100 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800">
                    Draft
                  </span>
                )}
              </div>
              <div className="mt-1 text-gray-600">ID: {data.id}</div>
            </div>
          </div>
        </div>
      </div>
    </ContextMenuWrapper>
  )
}

function PerformTaskDisplay({ data }: { data: FramerPerformTaskResult }) {
  return (
    <div className="rounded-2xl border border-gray-200/50 bg-white/70 text-black shadow-sm">
      <div className="flex items-start gap-3 px-4 py-3">
        <div className="mt-0.5 flex-shrink-0">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-50">
            <SiFramer className="h-4 w-4 text-purple-600" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-gray-900">Task completed</div>
          <div className="mt-1.5">
            <EnhancedMarkdown className="text-xs">{data.summary}</EnhancedMarkdown>
          </div>
          {data.changes.length > 0 && (
            <div className="mt-3">
              <CollapsibleList
                title="Changes"
                itemCount={data.changes.length}
                defaultExpanded={data.changes.length <= 5}
              >
                {data.changes.map((change, idx) => (
                  <div
                    key={idx}
                    className="rounded-lg border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs"
                  >
                    <div className="font-medium text-gray-900">{change.action}</div>
                    <div className="text-gray-500">{change.details}</div>
                  </div>
                ))}
              </CollapsibleList>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// function GetPublishUrlsDisplay({ data }: { data: FramerGetPublishUrlsResult }) {
//   const contextActions = []

//   if (data.productionUrl) {
//     contextActions.push({
//       id: 'copy-production',
//       label: 'Copy Production URL',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         await copyToClipboard(data.productionUrl!)
//       },
//     })
//   }

//   if (data.stagingUrl) {
//     contextActions.push({
//       id: 'copy-staging',
//       label: 'Copy Staging URL',
//       icon: <Copy className="h-3.5 w-3.5" />,
//       onClick: async () => {
//         await copyToClipboard(data.stagingUrl!)
//       },
//     })
//   }

//   return (
//     <ContextMenuWrapper actions={contextActions}>
//       <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
//         <div className="flex items-start gap-4 px-4 py-3">
//           <div className="mt-1 flex-shrink-0">
//             <div className="rounded-full bg-indigo-100 p-2">
//               <ExternalLink className="h-5 w-5 text-indigo-600" />
//             </div>
//           </div>
//           <div className="min-w-0 flex-1">
//             <div className="text-sm font-semibold text-gray-900">Publish URLs</div>
//             <div className="mt-2 space-y-2">
//               {data.productionUrl && (
//                 <a
//                   href={data.productionUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="block rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs hover:bg-gray-100"
//                 >
//                   <div className="font-medium text-gray-900">Production</div>
//                   <div className="mt-1 truncate text-blue-600">{data.productionUrl}</div>
//                 </a>
//               )}
//               {data.stagingUrl && (
//                 <a
//                   href={data.stagingUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="block rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs hover:bg-gray-100"
//                 >
//                   <div className="font-medium text-gray-900">Staging</div>
//                   <div className="mt-1 truncate text-blue-600">{data.stagingUrl}</div>
//                 </a>
//               )}
//               {!data.productionUrl && !data.stagingUrl && (
//                 <div className="rounded-2xl border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600">
//                   No publish URLs available
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </ContextMenuWrapper>
//   )
// }

function FramerActionsDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const inputs = framerActions.argsSchema.safeParse(nodeExecution.inputs.functionArgs)

  if (!inputs.success) {
    return <SchemaValidationError error={inputs.error} nodeExecution={nodeExecution} />
  }

  const schema = getToolResultSchema(framerActions, inputs.data)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const data = parseResult.data
  const actionName = inputs.data.action.name

  // Determine which display to show based on action name
  switch (actionName) {
    // case 'listCollections':
    //   return <ListCollectionsDisplay data={data as FramerListCollectionsResult} />
    // case 'listArticles':
    //   return <ListArticlesDisplay data={data as FramerListArticlesResult} />
    case 'getArticle':
      return <GetArticleDisplay data={data as FramerGetArticleResult} />
    case 'createArticle':
      return <CreateArticleDisplay data={data as FramerCreateArticleResult} />
    case 'updateArticle':
      return <UpdateArticleDisplay data={data as FramerUpdateArticleResult} />
    case 'performTask':
      return <PerformTaskDisplay data={data as FramerPerformTaskResult} />
    // case 'getPublishUrls':
    //   return <GetPublishUrlsDisplay data={data as FramerGetPublishUrlsResult} />
    default:
      return (
        <div className="rounded-2xl border border-gray-200/50 bg-white/70 text-black shadow-sm">
          <div className="flex items-start gap-3 px-4 py-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-50">
              <SiFramer className="h-4 w-4 text-purple-600" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">Framer Action Complete</span>
              </div>
              <div className="mt-1 text-xs text-gray-600">Action: {actionName || 'unknown'}</div>
            </div>
          </div>
        </div>
      )
  }
}

function downloadFramerActions(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function framerActionsToMarkdown(nodeExecution: NodeExecution): string {
  const schema = getToolResultSchema(framerActions, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return '## Error: Schema validation failed\n\nUnable to export results due to data structure mismatch.'
  }

  const data = parseResult.data
  const actionName = (nodeExecution.inputs as any)?.action?.name

  switch (actionName) {
    //     case 'listCollections': {
    //       const collections = (data as FramerListCollectionsResult).collections
    //       return `## Framer Collections (${collections.length})

    // ${collections.map((c) => `- **${c.name}** (${c.fieldCount} fields) - ID: ${c.id}`).join('\n')}

    // ---
    // `
    //     }
    //     case 'listArticles': {
    //       const result = data as FramerListArticlesResult
    //       return `## Framer Articles (${result.articles.length} of ${result.total})

    // ${result.articles
    //   .map(
    //     (a) =>
    //       `- **${a.slug}** ${a.draft ? '(Draft)' : '(Published)'}\n  - ID: ${a.id}\n  - Fields: ${Object.keys(a.fieldData).join(', ')}`
    //   )
    //   .join('\n')}

    // ---
    // `
    //     }
    case 'getArticle': {
      const article = data as FramerGetArticleResult
      return `## Article: ${article.slug}

**Status:** ${article.draft ? 'Draft' : 'Published'}
**ID:** ${article.id}

**Fields:**
${Object.entries(article.fieldData)
  .map(([key, value]) => `- **${key}:** ${String(value)}`)
  .join('\n')}

---
`
    }
    case 'createArticle': {
      const article = data as FramerCreateArticleResult
      return `## Article Created

**Slug:** ${article.slug}
**Status:** ${article.draft ? 'Draft' : 'Published'}
**ID:** ${article.id}

---
`
    }
    case 'updateArticle': {
      const article = data as FramerUpdateArticleResult
      return `## Article ${article.updated ? 'Updated' : 'Unchanged'}

**Slug:** ${article.slug}
**Status:** ${article.draft ? 'Draft' : 'Published'}
**ID:** ${article.id}

---
`
    }
    case 'performTask': {
      const task = data as FramerPerformTaskResult
      const changes = task.changes
        .map((change) => `- **${change.action}**: ${change.details}`)
        .join('\n')
      return `## Framer Task Completed

**Summary:** ${task.summary}

### Changes Made:
${changes}

---
`
    }
    //     case 'getPublishUrls': {
    //       const urls = data as FramerGetPublishUrlsResult
    //       return `## Publish URLs

    // ${urls.productionUrl ? `**Production:** ${urls.productionUrl}` : ''}
    // ${urls.stagingUrl ? `**Staging:** ${urls.stagingUrl}` : ''}

    // ---
    // `
    //     }
    default:
      return `## Framer Action: ${actionName}

\`\`\`json
${JSON.stringify(data, null, 2)}
\`\`\`

---
`
  }
}

export const FramerActionsDisplay = createWorkflowToolComponent(
  FramerActionsDisplayComponent,
  downloadFramerActions,
  framerActionsToMarkdown
)
